/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonTemplate,
    JsonTemplateFromJSON,
    JsonTemplateFromJSONTyped,
    JsonTemplateToJSON,
} from './JsonTemplate';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonTemplate
 */
export interface ApiResultOfListOfJsonTemplate {
    /**
     * 
     * @type {Array<JsonTemplate>}
     * @memberof ApiResultOfListOfJsonTemplate
     */
    data?: Array<JsonTemplate>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonTemplate
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonTemplate
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonTemplate
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonTemplate
     */
    result?: ApiResultOfListOfJsonTemplateResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonTemplateResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonTemplateFromJSON(json: any): ApiResultOfListOfJsonTemplate {
    return ApiResultOfListOfJsonTemplateFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonTemplateFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonTemplateToJSON(value?: ApiResultOfListOfJsonTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonTemplateToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

